/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-ms-flex:1 1 auto;flex:1 1 auto;display:-ms-flexbox;display:flex;padding:24px}app-stack-layout[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{-ms-flex-negative:0;flex-shrink:0}.d-flex[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex}"];
export { styles as styles };
